import {ModalReducer as modalDialog} from 'mc/lib/modal';
import {reducer as toastr} from 'react-redux-toastr';
import {combineReducers} from 'redux';
import {reducer as form} from 'redux-form';
import app from './appReducer';

export default combineReducers({
    modalDialog,
    app,
    toastr,
    form,
});
